import React from 'react';
import PropTypes from 'prop-types';

import './Card.scss';

const Card = ({ children, className }) =>
	<div className={`Card ${className}`}>
		{React.Children.toArray(children)}
	</div>;

Card.propTypes = {
	className: PropTypes.string,
	children: PropTypes.any.isRequired,
};

Card.defaultProps = {
	className: '',
};

export default Card;



// WEBPACK FOOTER //
// ./src/ui/components/Card/index.js